import axios, { AxiosError } from 'axios';
import { IResetPassword } from 'src/interfaces';
import http from './http';

class ResetPasswordService {
  static resetPassword(data: IResetPassword, token: string) {
    return http
      .post('/auth/reset-password', data, {
        headers: { 'Recovery-Token': `${token}` },
      })
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default ResetPasswordService;
